// extracted by mini-css-extract-plugin
export var Modal = "BowerModal-module--Modal--2YqXZ";
export var Overlay = "BowerModal-module--Overlay--dwgKy";
export var Content = "BowerModal-module--Content--3YY46";
export var PopupImage__Mobile = "BowerModal-module--PopupImage__Mobile--2fZh9";
export var PopupImage__Mobile__BathShower = "BowerModal-module--PopupImage__Mobile__BathShower--z8w47";
export var artwork_mobile_bath = "BowerModal-module--artwork_mobile_bath--2NIPQ";